'use es6';

import { List } from 'immutable';
import { deref, unwatch, watch } from 'atom';
import { isResolved } from 'reference-resolvers/utils';
import CurrencySelect from 'ui-addon-i18n/components/CurrencySelect';
import FilterOperatorErrorType from '../propTypes/FilterOperatorErrorType';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import ReferenceResolverAllType from 'reference-resolvers/schema/ReferenceResolverAllType';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { jsx as _jsx } from "react/jsx-runtime";
export default class FilterOperatorCurrencyCodeInput extends PureComponent {
  constructor() {
    super();
    this.handleChange = evt => {
      const {
        multi,
        onChange
      } = this.props;
      if (multi) {
        onChange(syntheticEvent(List(evt.target.value)));
        return;
      }
      onChange(evt);
    };
    this.handleOptionsChange = options => {
      if (isResolved(options)) {
        this.setState({
          currencyCodes: List(options.map(record => record.id))
        });
      }
    };
    this.state = {
      currencyCodes: List()
    };
    this.referenceAtom = null;
  }
  componentDidMount() {
    this.configureResolver(this.props);
  }
  componentDidUpdate(nextProps) {
    if (nextProps.resolver !== this.props.resolver) {
      if (this.referenceAtom) {
        unwatch(this.referenceAtom, this.handleOptionsChange);
      }
      this.configureResolver(nextProps);
    }
  }
  componentWillUnmount() {
    if (this.referenceAtom) {
      unwatch(this.referenceAtom, this.handleOptionsChange);
    }
  }
  configureResolver(props) {
    const {
      resolver,
      value
    } = props;
    if (value) {
      this.referenceAtom = resolver.all();
      watch(this.referenceAtom, this.handleOptionsChange);
      this.handleOptionsChange(deref(this.referenceAtom));
    }
  }
  getValue() {
    const {
      multi,
      value
    } = this.props;
    if (multi) {
      return value ? value.toArray() : [];
    }
    return value;
  }
  render() {
    const {
      currencyCodes
    } = this.state;
    const {
      error,
      multi
    } = this.props;
    const isError = error.get('error');
    const errorMessage = error.get('message');
    return /*#__PURE__*/_jsx(UIFormControl, {
      error: isError,
      validationMessage: isError ? errorMessage : null,
      children: /*#__PURE__*/_jsx(CurrencySelect, {
        currenciesFilter: currency => currencyCodes.includes(currency.value),
        currencyStyle: "long",
        multi: multi,
        onChange: this.handleChange,
        value: this.getValue()
      })
    });
  }
}
FilterOperatorCurrencyCodeInput.propTypes = {
  error: FilterOperatorErrorType.isRequired,
  multi: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  resolver: ReferenceResolverAllType.isRequired,
  value: PropTypes.string
};